<script setup>
import { useI18n } from '../../i18n.js'
import { errorCategories, outcomes, setDraftErrorCategory, setDraftOutcome } from '../../monitoring/journalState.js'
defineProps({ model: Object })
const { t } = useI18n()
</script>
<template>
  <label>{{ t('outcome') }}<select :aria-label="t('outcome')" :value="model.outcome" @change="setDraftOutcome(model, $event.target.value)"><option value="">{{ t('journalAllOutcomes') }}</option><option v-for="value in outcomes" :key="value" :value="value">{{ t(`journalOutcome_${value}`) }}</option></select></label>
  <label>{{ t('journalErrorType') }}<select :aria-label="t('journalErrorType')" :value="model.errorCategory" @change="setDraftErrorCategory(model, $event.target.value)"><option value="">{{ t('journalAllErrorTypes') }}</option><option v-for="value in errorCategories" :key="value" :value="value">{{ t(`journalError_${value}`) }}</option></select></label>
</template>
